import { define as input } from "./input";
import { define as textarea } from "./textarea";
input();
textarea();
